module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 77
// module chunks = 0